/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { Variable, Operator, Function, FormulaBlockType } from './types';

export const createFormula = (blocks: Array<Variable | Operator | Function>) => {
  let formula = '';
  blocks.forEach((block: Variable | Operator | Function, index: number) => {
    if (block.type === FormulaBlockType.Operator) {
      formula += block.value;
    } else if (block.type === FormulaBlockType.Variable) {
      if (index && blocks[index - 1].type === FormulaBlockType.Variable) {
        formula += ',';
      }
      formula += block.slug;
    } else if (block.type === FormulaBlockType.Function) {
      formula += `${block.value}(`;
      formula += block.values.map(v => v.slug).join(',');
      formula += ')';
    }
  });
  return formula;
};
